import { useIsProjectTeamsEnabled } from ':cloud/hooks/featureFlags/useIsProjectTeamsEnabled';
import useProjectNavigation from ':cloud/hooks/useProjectNavigation';
import { AccessTable } from ':cloud/widgets/access/teams/AccessTable';
import { AccessTableNEW } from ':cloud/widgets/access/teams/AccessTableNEW';

export function TeamPage() {
  const isProjectTeamsEnabled = useIsProjectTeamsEnabled();
  useProjectNavigation();

  return isProjectTeamsEnabled ? <AccessTableNEW /> : <AccessTable />;
}
